import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	slowQueryGuard,
	SLOW_QUERY_DEFAULT_TIMEOUT,
} from '@confluence/query-preloader-tools/entry-points/slowQueryGuard.ts';
import {
	useChangeHistoryDataQuery,
	type useChangeHistoryDataQuery$data,
	type useChangeHistoryDataQuery$variables,
} from '@confluence/change-history-macro/entry-points/useChangeHistoryDataQuery.ts';
import { buildChangeHistoryDataQueryVariables } from '@confluence/change-history-macro/entry-points/buildChangeHistoryDataQueryVariables.ts';

import type {
	MacroContentNode,
	MacroPreloadContext,
	MacroPreloadHandler,
} from '../preloadMacroData.ts';

/**
 * Preload handler for the change-history macro.
 *
 * For a change-history extension node found in the ADF content, this handler
 * fires the same initial content history query used by the renderer to
 * populate the Relay store before hydration.
 */
export const changeHistoryPreloadHandler: MacroPreloadHandler = {
	extensionKey: 'change-history',

	routes: ['view', 'space-overview', 'edit', 'live'],

	preload: async (_node: MacroContentNode, context: MacroPreloadContext): Promise<void> => {
		try {
			const variables = buildChangeHistoryDataQueryVariables(context.contentId);
			await slowQueryGuard(
				'changeHistoryPreload',
				() =>
					query<useChangeHistoryDataQuery$data, useChangeHistoryDataQuery$variables>({
						query: useChangeHistoryDataQuery,
						variables,
						context: { single: true },
					}),
				SLOW_QUERY_DEFAULT_TIMEOUT,
			);
		} catch {
			return;
		}
	},
};
